import React from 'react'
import styled from 'styled-components'

import { colorYellow } from '../../Global/global-styles'
import DepartureCount from '../../Components/DepartureCount/DepartureCount'
import ResponsiveFont from '../../Components/ResponsiveFont/ResponsiveFont'
import { logTrace } from '../../Global/App/ApplicationInsights'
import { SeverityLevel } from '@microsoft/applicationinsights-common'

const List: React.FC<{
    data: any
    destination: string
}> = ({ data, destination }) => {
    if (!data || !data.length) {
        logTrace('data or data.length not defined in List component', SeverityLevel.Warning)
        return null // TODO: Return error page?
    }

    return (
        <DeparturesList>
            <DeparturesTitle>
                <ResponsiveFont ratio={25}>To {destination}</ResponsiveFont>
            </DeparturesTitle>
            <Departures>
                {data.map((d: any, i: number) => (
                    <DepartureCount key={i} count={d.timeLeft} position={i + 1} isLast={false} />
                ))}
            </Departures>
        </DeparturesList>
    )
}

export default List

const DeparturesList = styled.div`
    position: relative;
    height: 100%;
    width: calc(100% - 20vw);
    padding: 14vh 0;
    margin: 0 5vw;

    @media (orientation: portrait) {
        width: 100%;
        height: calc(100% - 30vh);
        padding: 0 7vw;
        margin: 10vh 0;
    }
`

const Departures = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    margin-left: 5.5vw;

    @media (orientation: portrait) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 3vw;
        width: 80%;
        margin-top: 3vh;
    }
`

const DeparturesTitle = styled.div`
    font-family: TransferSans, 'Transfer Sans', sans-serif;
    color: ${colorYellow};
`
